module.exports = __webpack_public_path__ + "img/bg6.f39cf32f.png";